import React from "react";
import Button from "Components/button/Button";
import Loader from "Components/loader/Loader";
import PropTypes from "prop-types";
import { alertSuccess, alertError } from "Utils/alerts";
import { displayFormattedDate } from "Utils/dateFormats";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";

import cx from "classnames";
import s from "./ownershipCheckDNS.scss";

export default class OwnershipCheckDNS extends React.Component {
  constructor(props) {
    super(props);
    let state;
    if (props.isVerifing) {
      this.timeout = window.setTimeout(() => {
        props.checkDNSVerificationStatus(this.props.aliasDomainCode);
        this.setState({ isRefreshing: false });
      }, 5000);
      state = { isRefreshing: true };
    } else {
      state = { isRefreshing: false };
    }

    this.state = state;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.hasValidationSuccessed || nextProps.skipped) {
      alertSuccess(t("alert.ownershipCheckSuccess"));
      this.props.resetAndGoBack();
    }

    if (nextProps.hasValidationFailed && !this.props.hasValidationFailed) {
      if (this.props.isAlias) {
        this.props.refreshAliasDomain(this.props.aliasDomainCode);
      } else {
        this.props.refreshDomain();
      }
      alertError(t("alert.ownershipCheckFail"));
    }

    if (nextProps.isVerifing && !this.state.isRefreshing) {
      this.timeout = window.setTimeout(() => {
        this.props.checkDNSVerificationStatus(this.props.aliasDomainCode);
        this.setState({ isRefreshing: false });
      }, 2500);
      this.setState({ isRefreshing: true });
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  verifyDNS() {
    if (this.props.isAlias) {
      this.props.verifyDNS(this.props.aliasDomainCode);
    } else {
      this.props.verifyDNS();
    }
  }

  skipOwnershipCheck() {
    if (this.props.isAlias) {
      this.props.skipOwnershipCheck(this.props.aliasDomainCode);
    } else {
      this.props.skipOwnershipCheck();
    }
  }

  renderVerifing() {
    return (
      <div className={cx(s.ownershipCheckDNS, s.loader)}>
        <Loader />
        <div className={s.loaderText}>
          <TranslatedString>infoMsg.verifingOwnershipCheck</TranslatedString>
        </div>
      </div>
    );
  }

  renderNotVerified({ isloggedUserWholesale, isTeamMemberOfAWholesale, isLoggedUserAdmin }) {
    return (
      <div className={s.ownershipCheckDNS}>
        <div className={s.text}>
          <TranslatedString>ownershipCheck.dns.instruction.part1</TranslatedString>
        </div>
        <div>
          <div className={s.headerCode}>
            <div>{t("listTable.header.title.name")}</div>
            <div>{t("listTable.header.title.type")}</div>
            <div>{t("listTable.header.title.ip")}</div>
          </div>

          <div className={s.rowCode}>
            <div>
              {this.props.possessionARecord}.{this.props.domainName}
            </div>
            <div>A</div>
            <div>185.97.217.16</div>
            {/*`${this.props.possessionARecord}.${this.props.domainName} A 185.97.217.16`*/}
          </div>
        </div>

        <div className={s.text}>
          <TranslatedString>ownershipCheck.dns.instruction.part2</TranslatedString>
          {displayFormattedDate(this.props.updatedAt, true)}
        </div>

        <div className={s.footer}>
          {(isloggedUserWholesale || isTeamMemberOfAWholesale || isLoggedUserAdmin) && (
            <Button
              className={s.skipBtn}
              onClick={this.skipOwnershipCheck.bind(this)}
              loading={this.props.isSkipping}
              color="outline"
            >
              button.skipOwnershipCheck
            </Button>
          )}
          <div className={s.btnRight}>
            <Button color="text" onClick={() => this.props.resetAndGoBack()}>
              button.cancel
            </Button>
            <Button onClick={this.verifyDNS.bind(this)} loading={this.props.isVerifing}>
              button.verifyDNS
            </Button>
          </div>
        </div>
      </div>
    );
  }
  render() {
    if (this.props.isVerifing) {
      return this.renderVerifing();
    }
    return this.renderNotVerified(this.props);
  }
}
